import { CatModel, PdfItemModel, SlideModel } from "src/core/categories/categories.models";
import { TagModel } from "./tag.model";

export class PostModel {
    public content: string;
    public createdAt: string;
    public id: number;
    public image: string;
    public maincategoryId: number;
    public subtitle: string;
    public title: string;
    public updatedAt: string;
    public userId: number;
    public favorite: number;
    public notification: number;

    public tags: TagModel[];
    public categories: CatModel[];
    public pdfs: PdfItemModel[];
    public sliders: SlideModel[];

    constructor(res: any) {
        this.content = res.content || '';
        this.createdAt = res.createdAt || null;
        this.id = res.id;
        this.image = res.image || '';
        this.maincategoryId = res.maincategoryId || null;
        this.subtitle = res.subtitle || '';
        this.title = res.title || '';
        this.updatedAt = res.updatedAt || null;
        this.userId = res.userId || null;
        this.favorite = res.favorite || 0;
        this.notification = res.notification || 0;

        this.tags = res.tags ? res.tags : [];
        this.categories = res.categories ? res.categories : [];
        this.pdfs = res.pdfs ? res.pdfs : [];
        this.sliders = res.sliders ? res.sliders : [];
    }
}